module.exports = __webpack_public_path__ + "img/fi-rr-angle-double-right.78b6e340.svg";